import { useState } from 'react';
import { AiFillLinkedin, AiFillGithub } from 'react-icons/ai';
import { MdNightlight, MdLightMode } from "react-icons/md";

import "./css/Footer.css";

export default function Footer() {

    const [nightMode, setNightMode] = useState<boolean>(false);
    const body = document.body;

    body.classList.add("light");

    function handleNightMode(): void {

        nightMode
            ? body.classList.replace("dark", "light")
            : body.classList.replace("light", "dark");

        setNightMode(!nightMode);
    }

    return (
        <div className="footer fadeIn">
            <div className="content-footer" >
                <a data-hover="Linkedin" className="hovertext-footer link-footer" href="https://www.linkedin.com/in/rami-dominguez-full-stack/" target="_blank" rel="noreferrer noopener">
                    <AiFillLinkedin className="icons-footer" />
                </a>
                <a data-hover="GitHub" className="hovertext-footer link-footer" href="https://github.com/siprem10" target="_blank" rel="noreferrer noopener">
                    <AiFillGithub className="icons-footer" />
                </a>
                {!nightMode
                    ? <p data-hover="Tema Oscuro" className="hovertext-footer link-footer"><MdNightlight onClick={handleNightMode} className="icons-footer cora" /></p>
                    : <p data-hover="Tema Claro" className="hovertext-footer link-footer"><MdLightMode onClick={handleNightMode} className="icons-footer cora" /></p>}
            </div>
        </div>
    );
}